module.exports = __webpack_public_path__ + "img/image02.e93e1204.jpg";